import {
  DocumentProspectingBaseFormExecutionResult,
  ProspectingBaseFormValues,
  SegmentedDocumentProspectingDetailsFormSchemaType,
  SegmentedDocumentProspectingDetailsFormValuesType,
} from '../../../models/DocumentProspecting'

export const buildName = (firstName: string, lastName: string) => {
  const validNameParts = [firstName, lastName].filter((e) => e)
  if (!validNameParts.length) {
    return ''
  }
  return validNameParts.join(' ')
}

export const mapProspectingBaseFormExecutionResult = (
  prospectingBaseFormExecutionResult: DocumentProspectingBaseFormExecutionResult,
): ProspectingBaseFormValues => {
  const { firstName, lastName, email } = prospectingBaseFormExecutionResult
  return {
    firstName: firstName ?? '',
    lastName: lastName ?? '',
    email: email ?? '',
  }
}

export const getAggregatedSchemaForIntegrationWithSegmentedSchema = (schema: SegmentedDocumentProspectingDetailsFormSchemaType) => {
  return Object.fromEntries(Object.entries(schema).map(([key, panel]) => [key, panel.schema]))
}

export const getAggregatedValuesForIntegrationWithSegmentedSchema = (values: SegmentedDocumentProspectingDetailsFormValuesType) => {
  return Object.fromEntries(Object.entries(values).map(([key, panel]) => [key, panel.values]))
}
